/** Formateadores y etiquetas de presentación DOOH (US 2.6, es-CO). */
import type { DoohMediaKind, DoohOrientation } from '@goelectric/shared-types';

export const MEDIA_KIND_LABELS: Record<DoohMediaKind, string> = {
  IMAGE: 'Imagen',
  VIDEO: 'Video',
};

export const ORIENTATION_LABELS: Record<DoohOrientation, string> = {
  LANDSCAPE: 'Horizontal',
  PORTRAIT: 'Vertical',
};

/** Tamaño legible (B/KB/MB) para los metadatos de la biblioteca. */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined || Number.isNaN(bytes)) {
    return '—';
  }
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  const kb = bytes / 1024;
  if (kb < 1024) {
    return `${kb.toFixed(0)} KB`;
  }
  return `${(kb / 1024).toFixed(1)} MB`;
}

/** Duración legible en segundos (`15 s`, `1 min 30 s`). */
export function formatDuration(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined || seconds <= 0) {
    return '—';
  }
  if (seconds < 60) {
    return `${seconds} s`;
  }
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return rest === 0 ? `${minutes} min` : `${minutes} min ${rest} s`;
}

/** Resolución legible (`1920 × 1080`); `—` si falta algún lado. */
export function formatResolution(width: number | null, height: number | null): string {
  if (!width || !height) {
    return '—';
  }
  return `${width} × ${height}`;
}

/** Cantidad de ítems con plural correcto (`1 ítem`, `2 ítems`). */
export function formatItemCount(count: number): string {
  return `${count} ${count === 1 ? 'ítem' : 'ítems'}`;
}

/** Checksum acortado para tablas (primeros 12 hex + elipsis). */
export function formatChecksum(checksum: string | null | undefined): string {
  if (!checksum) {
    return '—';
  }
  return checksum.length > 12 ? `${checksum.slice(0, 12)}…` : checksum;
}

/** Fecha/hora corta local (es-CO). */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) {
    return '—';
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString('es-CO', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
